import vuetifyToast from 'vuetify-toast'

const queueToast = (messages, color = 'error', icon = 'warning') => {
  let count = 0
  let localMessages = []
  if (Array.isArray(messages)) {
    localMessages = messages
  } else {
    localMessages.push(messages)
  }
  localMessages.forEach((item) => {
    setTimeout(function () {
      vuetifyToast.show({
        text: item,
        color,
        timeout: 2000,
        icon,
      })
    }, 2100 * count)
    count++
  })
}

export default queueToast
